module.exports = __webpack_public_path__ + "img/article_create.c0bee40d.png";